import gmx_zMixins            from '../../../../../includes/Jmixins/zMixins'


// Locally declared common Data-Props & SVG Drawing Support
import lmx_localData          from '../primitives/localData'
import lmx_Watching           from './Watching' 
import lmx_LocalValues        from './set_LocalValues'
import lmx_draw_Forms         from './draw_Forms'
import lmx_draw_Overall        from './draw_Overall'
import lmx_draw_EPCs          from './draw_EPCs'
import lmx_draw_Area          from './draw_Area'
import lmx_Events             from './Events'


export default {
  
  mixins: [
    gmx_zMixins, 
    lmx_localData,
    
    // Local Mixins
    lmx_Watching,
    lmx_LocalValues,
    lmx_draw_Forms,
    lmx_draw_Overall,
    lmx_draw_EPCs,
    lmx_draw_Area,
    lmx_Events,
  ],

}
